export const state = {
  ageGateToken: localStorage.getItem('ageGateToken')?true:false, 
  loggedIn: false,
  activeSection: 'beer',
  triggerSpring: 0,
  scrollMotion: 'upStart',
  edgeScrolling: 0,
  loaded: false
}
